import api from "../../../services/api";

const getHealth = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/master/health").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTHEALTH", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const insertMasterHealth = ({ state }) => {
  return new Promise((resolve, reject) => {
    if (state.tempMasterHealth.id) {
      api
        .put("/master/health/" + state.tempMasterHealth.id, {
          ...state.tempMasterHealth,
          id: undefined
        })
        .then(
          response => {
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
    } else {
      api.post("/master/health", state.tempMasterHealth).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    }
  });
};

const deleteMasterHealth = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.delete("/master/health/" + state.idMasterHealth).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};

const getMedicalCate = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/medical/category").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESMEDICALCATE", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const getUserHealth = ({ state, commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/user/health/" + state.id_user).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESHEALTHUSER", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const updateUserHealth = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.put("/user/health", state.temp_userHealth).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};

const deleteUserHealth = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.delete("/user/health/" + state.id_health).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
export default {
  getHealth,
  insertMasterHealth,
  getMedicalCate,
  deleteMasterHealth,
  getUserHealth,
  updateUserHealth,
  deleteUserHealth
};
